import { render, staticRenderFns } from "./DispenserSelect.vue?vue&type=template&id=193f0754"
import script from "./DispenserSelect.vue?vue&type=script&lang=js"
export * from "./DispenserSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports